import { cva, VariantProps } from "class-variance-authority";
export { default as TotalsByStatus } from './TotalsByStatus.vue';

export const totalStatusVariants = cva('rounded-full border-10 p-2', {
  variants: {
    variant: {
      'pending': 'border-amber-100 bg-amber-200 text-amber-800',
      'paid': 'border-green-50 bg-green-100 text-green-700',
      'canceled': 'border-red-50 bg-red-100 text-red-700',
      'released': 'border-yellow-50 bg-yellow-100 text-yellow-700'
    },

  },
  defaultVariants: {
    variant: 'pending'
  }
})

export type TotalStatusVariants = VariantProps<typeof totalStatusVariants>
